export function getMaxMin(values: number[]): [number, number] {
  let max = Number.NEGATIVE_INFINITY;
  let min = Number.POSITIVE_INFINITY;

  for (const value of values) {
    max = Math.max(max, value);
    min = Math.min(min, value);
  }

  return [max, min];
}
